module.exports = __webpack_public_path__ + "img/shop.0a309731.svg";